'use client';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { Tout, CardImage, Slide } from './styles';

export interface FeatureCardProps {
  toutContent: ToutContentProps;
  backgroundImage: MediaType;
  alt?: string;
}

const FeatureCarouselCard = ({ toutContent, backgroundImage, alt }: FeatureCardProps) => {
  const lgAndUp = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
  const mdAndUp = useMediaQuery((theme: any) => theme.breakpoints.up('md'));
  const smAndUp = useMediaQuery((theme: any) => theme.breakpoints.up('sm'));
  const xsAndUp = useMediaQuery((theme: any) => theme.breakpoints.up('xs'));
  let backgroundImageUrl;

  if (lgAndUp) {
    backgroundImageUrl = buildImageSrc(backgroundImage, 2000, 9, 5);
  } else if (mdAndUp) {
    backgroundImageUrl = buildImageSrc(backgroundImage, 1280, 7, 5);
  } else if (smAndUp) {
    backgroundImageUrl = buildImageSrc(backgroundImage, 960, 1, 1);
  } else if (xsAndUp) {
    backgroundImageUrl = buildImageSrc(backgroundImage, 600, 1, 1);
  }

  return (
    <Slide tabIndex={0}>
      <CardImage src={backgroundImageUrl} role="presentation" alt={alt} />
      <Tout
        dark
        divider
        narrowContent
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        align="left"
        {...toutContent}
        headingStyleVariant="h2"
        hasBackground={!!toutContent?.headerVariant}
      />
    </Slide>
  );
};

export default FeatureCarouselCard;
